const Types = {
  SELECT: '@protocolo-envio/SELECT',
  REMOVE: '@protocolo-envio/REMOVE',
  INCLUDE: '@protocolo-envio/INCLUDE',
  SELECT_MULTI: '@protocolo-envio/SELECT_MULTI',
  CLEAR_SELECT: '@protocolo-envio/CLEAR_SELECT',
  CLEARINCL: '@protocolo-envio/CLEARINCL',

  CANCEL: '@protocolo-envio/CANCEL',
  PAGE_CHANGED: '@protocolo-envio/PAGE_CHANGED',

  REQUEST_FAILURE: '@protocolo-envio/REQUEST_FAILURE',

  SAVE_REQUEST: '@protocolo-envio/SAVE_REQUEST',
  SAVE_SUCCESS: '@protocolo-envio/SAVE_SUCCESS',

  SELECTS_REQUEST: '@protocolo-envio/SELECTS_REQUEST',
  SELECTS_SUCCESS: '@protocolo-envio/SELECTS_SUCCESS',

  SEARCH_PROTOCOLO_REQUEST: '@protocolo-envio/SEARCH_PROTOCOLO_REQUEST',
  SEARCH_PROTOCOLO_SUCCESS: '@protocolo-envio/SEARCH_PROTOCOLO_SUCCESS',

  CLEAR: '@protocolo-envio/CLEAR',

  SEARCH_REQUEST: '@protocolo-envio/SEARCH_REQUEST',
  SEARCH_SUCCESS: '@protocolo-envio/SEARCH_SUCCESS',
  SEARCH_FAILURE: '@protocolo-envio/SEARCH_FAILURE',

  FORCE_INCLUDE: '@protocolo-envio/FORCE_INCLUDE',
  FORCE_INCLUDE_DOCUMENTOS: '@protocolo-envio/FORCE_INCLUDE_DOCUMENTOS',

  LISTA_PROMOTORAS_REQUEST: '@protocolo-envio/LISTA_PROMOTORAS_REQUEST',
  LISTA_PROMOTORAS_SUCCESS: '@protocolo-envio/LISTA_PROMOTORAS_SUCCESS',
  LISTA_LOJAS_REQUEST: '@protocolo-envio/LISTA_LOJAS_REQUEST',
  LISTA_LOJAS_SUCCESS: '@protocolo-envio/LISTA_LOJAS_SUCCESS',
  LISTA_CONVENIOS_REQUEST: '@protocolo-envio/LISTA_CONVENIOS_REQUEST',
  LISTA_CONVENIOS_SUCCESS: '@protocolo-envio/LISTA_CONVENIOS_SUCCESS',
  LISTA_PRODUTOS_REQUEST: '@protocolo-envio/LISTA_PRODUTOS_REQUEST',
  LISTA_PRODUTOS_SUCCESS: '@protocolo-envio/LISTA_PRODUTOS_SUCCESS',
  FILTER_PRODUTOS_POR_CONVENIO: '@protocolo-envio/FILTER_PRODUTOS_POR_CONVENIO',

  PROTOCOLO_MASSA_VALIDAR_REQUEST: '@protocolo-envio/PROTOCOLO_MASSA_VALIDAR_REQUEST',
  PROTOCOLO_MASSA_VALIDAR_SUCCESS: '@protocolo-envio/PROTOCOLO_MASSA_VALIDAR_SUCCESS',
  PROTOCOLO_MASSA_VALIDAR_FAUILURE: '@protocolo-envio/PROTOCOLO_MASSA_VALIDAR_FAUILURE',
  PROTOCOLO_MASSA_CLOSE: '@protocolo-envio/PROTOCOLO_MASSA_CLOSE',
  COMPLEMENTO_DOCUMENTOS_PENDENTES: '@protocolo-envio/COMPLEMENTO_DOCUMENTOS_PENDENTES',
};

export default Types;